<template>
  <van-nav-bar v-if="showHead" :title="currentTitle" :border="false" :fixed="fixedTop">
    <template #left v-if="showLeft">
      <!-- 完全自定义左侧内容 -->
      <div class="custom-back" @click="handleBack">
        <van-icon name="arrow-left" color="#333" size="18px" />
      </div>
    </template>
    <template #title>
      <div class="custom-title">
        <span class="title-text">{{ currentTitle }}</span>
      </div>
    </template>
  </van-nav-bar>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},

  data() {
    // 这里存放数据
    return {};
  },
  // 监听属性 类似于data概念
  computed: {
    // 获取当前路由的标题配置
    currentTitle() {
      return this.$route.meta.title || '默认标题';
    },
    // 是否显示返回按钮（排除首页）
    showBack() {
      return this.$route.path !== '/home';
    },
    // 是否显示搜索图标（根据路由配置）
    showLeft() {
      return this.$route.meta.showLeft;
    },
    //是否显示head
    showHead() {
      return this.$route.meta.showHead;
    },
    //是否固定在顶部
    fixedTop() {
      return this.$route.meta.fixedTop;
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // 返回按钮处理
    handleBack() {
      console.log(window.history.length);
      if (window.history.length <= 2) {
        this.$router.replace('/');
      } else {
        this.$router.back();
      }
    },
    // 右侧按钮处理
    handleRightClick() {
      if (this.$route.meta.rightAction) {
        this.$emit(this.$route.meta.rightAction);
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* 自定义头部样式 */
.van-nav-bar {
  background: #ffffff;
}
.custom-title {
  display: flex;
  align-items: center;
}

.title-text {
  color: #26292C;  /* 标题颜色 */
  font-size: 17px; /* 标题大小 */
  font-weight: 600;
}
</style>
